<template>
  <v-row>
    <v-col>
      <v-data-table
        v-model="selected"
        :show-select="totaleTotem > 0"
        item-key="_id"
        :headers="headers"
        :items="elencoTotem"
        :options.sync="options"
        :server-items-length="totaleTotem"
        :loading="loading"
        class="elevation-1"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, 100],
        }"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        @item-expanded="onItemExpanded"
        show-expand
        dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Gestione totem</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row no-gutters>
            <v-col>
              <v-icon class="mt-1" @click="esportaConfigurazione(item)" title="Esporta configurazione">mdi-download-multiple-outline</v-icon>
            </v-col>
            <v-col title="Importa configurazione">
              <v-file-input
                  v-model="filename"
                  dense
                  class="mt-0"
                  hide-input
                  hide-details
                  accept=".json"
                  prepend-icon="mdi-upload-multiple-outline"
                  @change="importaConfigurazione($event, item)"
                ></v-file-input>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="articoliSelected">
            <v-tabs dense v-model="tab[item._id]">
              <v-tab key="configurazione" class="articoliSelected">Template</v-tab>
              <v-tab key="tema">Tema</v-tab>
              <v-tab key="dettaglioProdotti">Dettaglio prodotti</v-tab>
              <v-tab key="ordinaProdotti">Ordina prodotti</v-tab>
              <v-tab key="allegati">Immagini</v-tab>
              <v-tab key="testi">Testi e lingue</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab[item._id]">
              <v-tab-item key="configurazione">
                <configurazione :item="item" />
              </v-tab-item>
              <v-tab-item key="tema">
                <tema :item="item" />
              </v-tab-item>
              <v-tab-item key="dettaglioProdotti">
                <dettaglio-prodotti
                  :item="item"
                  :refresh="trigRefreshProdotti"
                  @aggiorna="aggiornaTotem"
                />
              </v-tab-item>
              <v-tab-item key="ordinaProdotti">
                <ordina-prodotti
                  :item="item"
                  :refresh="trigRefreshProdotti"
                  @aggiorna="aggiornaOrdine"
                />
              </v-tab-item>              
              <v-tab-item key="allegati">
                <immagini
                  :codiceTotem="item.codice"
                  :alberaturaAssets="item.alberaturaAssets"
                  :triggerUpdate="triggerUpdate"
                  @change="onChangeFile"
                  @refresh="refresh"
                  @sincronizza="sincronizzaProdotti"
                  @prima-installazione="onPrimaInstallazione"
                />
              </v-tab-item>
              <v-tab-item key="testi">
                <v-expansion-panels multiple class="mt-2">
                  <v-expansion-panel
                    v-for="(language, index) in languages"
                    :key="index"
                    style="border: 1px solid #e0e0e0"
                    class="mb-2"
                  >
                    <v-expansion-panel-header>
                      <div class="d-flex justify-start align-center">
                        <v-checkbox v-model="language.isChecked"></v-checkbox>
                        <h2>{{ language.name }}</h2>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <language-input
                        @mutate="changeLanguage"
                        :item="language.text"
                        :path="[index, 'text']"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-btn
                  class="mt-2 mb-3"
                  color="success"
                  :loading="saving"
                  @click.stop="salvaLingue(item.codice)"
                  >Salva modifiche</v-btn
                >
              </v-tab-item>
            </v-tabs-items>
          </td>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="3" v-if="mostraAnteprima">
      <div style="position: sticky; top: 100px;">
        <div class="d-flex justify-between align-center">
          <h1>Anteprima totem</h1>
          <v-switch
            class="ms-auto"
            label="Contrasto"
            v-model="themeIndex"
          ></v-switch>
        </div>
        <v-col
          :style="{
            height: '70vh',
            ...this.convertToStyle('screen layout background', {
              background: configFromPath([
                'globalConfig',
                'screen-layout',
                'value',
                'background',
              ]),
            }),
            padding: '20px',
          }"
        >
          <!-- HEADER -->
          <v-row
            :style="{
              ...this.convertToStyle(
                'screen header style',
                configFromPath([
                  'globalConfig',
                  'screen-layout',
                  'value',
                  'header',
                  'style',
                ])
              ),
              height: '10%',
              marginBottom: '10px',
              borderRadius: '10px',
            }"
          >
            <div
              style="width: 100%;"
              class="d-flex justify-space-between align-center"
            >
              <div
                style="height: 50%; aspect-ratio: 2/1"
                class="ms-2 rounded d-flex justify-center align-center"
                :style="{
                  ...convertToStyle(
                    'product category background',
                    configFromPath([
                      'globalConfig',
                      'screen-layout',
                      'value',
                      'header',
                      'back-btn',
                    ])
                  ),
                }"
              >
                Button
              </div>
              <div
                style="height: 50%; aspect-ratio: 2/1; background-color: white;"
                class="d-flex justify-center align-center rounded-pill"
              >
                <h3>LOGO</h3>
              </div>
              <div
                style="height: 50%; aspect-ratio: 2/1"
                class="me-2 rounded d-flex justify-center align-center"
                :style="{
                  ...convertToStyle(
                    'product category background',
                    configFromPath([
                      'globalConfig',
                      'screen-layout',
                      'value',
                      'header',
                      'order-btn',
                    ])
                  ),
                }"
              >
                Button
              </div>
            </div>
          </v-row>
          <v-row
            :style="{
              height: '80%',
            }"
          >
            <!-- SIDEBAR -->
            <v-col
              cols="3"
              :style="{
                ...convertToStyle('product sidebar', {
                  background: configFromPath([
                    'configurations',
                    '2',
                    'config',
                    'sidebar',
                    'value',
                    'background',
                  ]),
                }),
                borderRadius: '10px',
              }"
            >
              <div
                :style="{
                  ...this.convertToStyle(
                    'product selected',
                    configFromPath([
                      'configurations',
                      '2',
                      'config',
                      'sidebar',
                      'value',
                      'selected',
                    ])
                  ),
                  borderRadius: '10px',
                  marginBottom: '10px',
                  height: '50px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }"
              >
                C{{ 1 }}
              </div>
              <div
                v-for="i in 4"
                :key="i"
                :style="{
                  ...convertToStyle('product category background', {
                    background: configFromPath([
                      'globalConfig',
                      'productPopup',
                      'value',
                      'category',
                      'background',
                    ]),
                  }),
                  ...convertToStyle('category title text', {
                    text: configFromPath([
                      'globalConfig',
                      'productPopup',
                      'value',
                      'category',
                      'title',
                      'text',
                    ]),
                  }),
                  borderRadius: '10px',
                  marginBottom: '10px',
                  height: '50px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }"
              >
                C{{ i + 1 }}
              </div>
            </v-col>

            <!-- MAIN CONTENT -->
            <v-col cols="9">
              <div
                class="d-flex flex-wrap"
                style="align-items: start; justify-content: space-evenly;"
              >
                <div
                  v-for="i in 8"
                  :key="i"
                  :style="{
                    ...convertToStyle(
                      'product background',
                      configFromPath([
                        'globalConfig',
                        'productCard',
                        'value',
                        'style',
                      ])
                    ),
                    borderRadius: '10px',
                    marginBottom: '10px',
                    marginRight: '10px',
                    width: '40%',
                    height: '100px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'black',
                  }"
                >
                  P{{ i }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </div>
      <!-- <div
        :style="{
          width: '100%',
          height: '100%',
          background: this.tema.themes[0].colors.background,
          padding: '20px',
        }"
        class="rounded-xl"
      > -->
    </v-col>
<!--     <v-col cols="3" v-else>

    </v-col> -->
  </v-row>
</template>

<script>
/* eslint-disable */
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import configurazioni from "@/services/configurazioniService";
import prodotti from "@/services/prodottiService";
import Immagini from "./immagini";
import Configurazione from "./configurazione";
import DettaglioProdotti from "./dettaglioProdotti.vue"
import OrdinaProdotti from "./ordinaProdotti"
import Tema from "./tema";
import LanguageInput from "./testi";
import { downloadTxt, slugify } from '@/components/helpers';
const crypto = require("crypto");

export default {
  name: "totem",
  components: {
    Configurazione,
    Tema,
    DettaglioProdotti,
    OrdinaProdotti,
    Immagini,
    LanguageInput
  },
  mixins: [verificaLicenza],
  data() {
    return {
      totaleTotem: 0,
      elencoTotem: [],
      selected: [],
      loading: true,
      options: { itemsPerPage: 50 },
      headers: [
        { text: "Codice", value: "codice", align: "start" },
        { text: "Descrizione", value: "descrizione" },
        { text: "Note", value: "note" },
        { text: "Ultimo ping", value: "stato.ultimoPing" },
        { text: 'Actions', value: 'actions', sortable: false },
        // { text: "", value: "speciali", width: 80 },
        { text: "", value: "data-table-expand" },
      ],
      expanded: [],
      singleExpand: true,
      tab: {},
      trigRefreshProdotti: 1,
      triggerUpdate: 0,
      destinazione: [],
      elencoIds: [],
      tema: this.$store.state.totem.theme,
      config: this.$store.state.totem.configurations,
      languages: this.$store.state.totem.languages,
      saving: false,
      themeIndex: false,
      mostraAnteprima: null,
      filename: null
    };
  },
  watch: {
    options: {
      async handler() {
        await this.getDataFromApi();
      },
      deep: true,
    },
  },
  async created() {},
  async mounted() {
    this.languages = this.recursiveProxy("languages", this.languages);
    await this.gestioneToken();
    await this.refresh();
  },
  methods: {
    importaConfigurazione(file, item) {
      if (!file) {
        return
      }
      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', async () => {
        const content = fr.result
        const data = Buffer.from(content.substring(content.indexOf(',') + 1), 'base64')
        const fileData = JSON.parse(data.toString())
        if (window.confirm('Confermi sovrascrittura configurazione esistente ? \n\n Tutti i dati precedenti saranno eliminati!')) {
          let elenco = await configurazioni.getConfigurazione('totem')
          let totem = elenco.totem.find(x => x.codice === item.codice)
          totem.struttura = fileData.struttura
          totem.alberaturaAssets = fileData.alberaturaAssets
          await configurazioni.modificaConfigurazione(elenco)
        }
        this.filename = null
      })
    },
    async esportaConfigurazione(item) {
      const daEsportare = {
        struttura: item.struttura,
        alberaturaAssets: item.alberaturaAssets
      }
      const nomeFile = slugify(`${item.codice}_${item.descrizione}`) + '.json'
      await downloadTxt(document, nomeFile, JSON.stringify(daEsportare, null, 2))
    },
    configFromPath(path) {
      let final = this.$store.state.totem.configurations;
      for (const key of path) {
        final = final[key];
      }
      return final;
    },
    styleToValue(variable) {
      if (this.tema.themes[Number(this.themeIndex)].colors[variable]) {
        return this.tema.themes[Number(this.themeIndex)].colors[variable];
      }
      return variable;
    },
    convertToStyle(label, style) {
      let current = {};
      if (Array.isArray(style)) {
        current = this.mergeStyles(style);
      } else {
        for (const key in style) {
          current[key] = this.styleToValue(style[key]);
        }
      }
      const final = {};
      const converter = {
        background: "backgroundColor",
        border: "borderColor",
        text: "color",
        // font: "fontFamily",
        //todo add fonts
      };
      // console.log(label, style);

      for (const key in current) {
        if (key === "font") continue;
        final[converter[key]] = current[key];
      }
      return final;
    },
    mergeStyles(styles) {
      let mergedStyle = {};
      styles.forEach((style) => {
        mergedStyle = {
          ...mergedStyle,
          ...this.$store.state.totem.configurations.globalConfig.styles.value[
            style
          ],
        };
      });
      for (const key in mergedStyle) {
        mergedStyle[key] = this.styleToValue(mergedStyle[key]);
      }
      return mergedStyle;
    },
    recursiveProxy(key, obj, path = []) {
      return new Proxy(obj, {
        get: (target, prop, receiver) => {
          const value = Reflect.get(target, prop, receiver);

          // Recursively wrap nested objects and arrays
          if (typeof value === "object" && value !== null) {
            return this.recursiveProxy(key, value, [...path, prop]);
          }
          return value;
        },
        set: (target, prop, value, receiver) => {
          // If assigning an object/array, wrap it with a proxy
          if (typeof value === "object" && value !== null) {
            value = this.recursiveProxy(key, value, [...path, prop]);
          }
          this.$store.commit(`SET_${key.toUpperCase()}`, {
            value,
            path: [...path, prop],
          });
          return Reflect.set(target, prop, value, receiver);
        },
      });
    },

    changeLanguage({ value, path }) {
      this.$store.commit("SET_LANGUAGES", { value, path });
    },
    async salvaLingue(codice) {
      this.saving = true;
      let elenco = await configurazioni.getConfigurazione("totem");
      let totem = elenco.totem.find((x) => x.codice === codice);
      totem.lingue = this.languages;
      await configurazioni.modificaConfigurazione(elenco);
      this.saving = false;
    },
    async refresh() {
      await this.getDataFromApi();
    },
    impostaInfoAnteprima() {
      let totem = this.elencoTotem.find((x) => x.codice === this.mostraAnteprima)
      this.$store.commit("SET_CONFIGURATION_TOTEM", {
          theme: totem.tema,
          configurations: totem.configurazione,
          languages: totem.lingue
        })
        this.languages = this.recursiveProxy(
          "languages",
          this.$store.state.totem.languages
        )
        this.configurations = this.recursiveProxy(
          "configurations",
          this.$store.state.totem.configurations
        )
        this.tema = this.$store.state.totem.theme
    },
    async getDataFromApi() {
      try {
        this.loading = true;
        const elenco = await configurazioni.getConfigurazione("totem", "totem");
        // this.elencoTotem = elenco
        this.elencoTotem = Object.assign([], elenco);
/*         this.$store.commit("SET_CONFIGURATION_TOTEM", {
          theme: elenco[0].tema,
          configurations: elenco[0].configurazione,
          languages: elenco[0].lingue,
        });
        this.languages = this.recursiveProxy(
          "languages",
          this.$store.state.totem.languages
        );
        this.configurations = this.recursiveProxy(
          "configurations",
          this.$store.state.totem.configurations
        );
        this.tema = this.$store.state.totem.theme; */
        // this.$store.state.totem.theme = config.tema;
        // this.$store.state.totem.configurations = config.configurazione;
        this.totaleTotem = elenco.length;
      } catch (err) {
        this.elencoTotem = [];
        this.totaleTotem = 0;
      } finally {
        this.trigRefreshProdotti++;
        this.loading = false;
      }
    },
    async aggiornaTotem(item, struttura) {
      let elenco = await configurazioni.getConfigurazione("totem");
      let totem = elenco.totem.find((x) => x.codice === item.codice);
      totem.struttura = struttura;
      await configurazioni.modificaConfigurazione(elenco);
    },
    async aggiornaOrdine(codiceTotem, categorie) {
      let elenco = await configurazioni.getConfigurazione("totem")
      let totem = elenco.totem.find((x) => x.codice === codiceTotem)
      totem.struttura = categorie
      await configurazioni.modificaConfigurazione(elenco)
    },    
    async onChangeFile____xxx({ codiceTotem, tipo, payload }) {
      let elenco = await configurazioni.getConfigurazione("totem");
      let totem = elenco.totem.find((x) => x.codice === codiceTotem);
      switch (tipo) {
        case "addFile":
        case "updateFile":
          totem.allegati = totem.allegati || [];
          for (let al of payload) {
            let allegato = totem.allegati.find((x) => x.codice === al.codice);
            if (!al.codice) {
              al.codice = crypto.randomBytes(16).toString("hex");
            }
            if (!allegato) {
              totem.allegati.push(al);
            } else {
              var index = totem.allegati.indexOf(allegato);
              if (~index) {
                totem.allegati[index] = al;
              }
            }
          }
          break;
        case "deleteFile":
          let allegato = totem.allegati.find(
            (x) => x.codice === payload.codice
          );
          if (allegato) {
            var index = totem.allegati.indexOf(allegato);
            totem.allegati.splice(index, 1);
          }
          break;
        default:
          break;
      }
      await configurazioni.modificaConfigurazione(elenco);
      await this.getDataFromApi();
      this.triggerUpdate++;
    },
    async refreshAllegati(item) {
      await this.refresh();
      const filtri = { id: item._id };
      let elenco = await configurazioni.getConfigurazione("totem");
      const totem = elenco.totem.find((x) => x.codice === item.codice);
      item.allegati = Object.assign([], totem ? totem.allegati || [] : []);
      this.triggerUpdate++;
    },
    pushIfNotExists(item) {
      if (!this.elencoIds.includes(item)) {
        this.elencoIds.push(item);
      }
    },
    elencoProdottiRic(items) {
      for (let el of items) {
        if (el.livello === 2) {
          this.pushIfNotExists(el.codice);
        }
        if (el.children) {
          this.elencoProdottiRic(el.children, el.id);
        }
      }
    },
    async sincronizzaProdotti(codiceTotem) {
      let elenco = await configurazioni.getConfigurazione("totem");
      let totem = elenco.totem.find((x) => x.codice === codiceTotem);
      // ------------------------------------------------
      this.elencoIds = [];
      this.elencoProdottiRic(totem.struttura);
      if (this.elencoIds.length === 0) {
        return;
      }

      let elencoProdotti = await prodotti.getProdottiByIds(this.elencoIds);
      let totemProdotti = totem.alberaturaAssets.cartelle.find(
        (x) => x.name === "prodotti"
      );
      let filesProdotti = totemProdotti.files;
      for (let p of elencoProdotti) {
        if (!filesProdotti.find((x) => x.idProdotto === p._id)) {
          let all = p.allegati?.find((x) => x.description.codice === "totem"); // TODO: cambiare nome della variabile --> useFor ?
          if (all) {
            let pp = {
              idProdotto: p._id,
              codice: all.codice,
              descrizione: p._id + " - " + all.name, // TODO: gestire
              name: all.name,
              pathFile: all.pathFile,
              type: all.type,
              size: all.size,
            };
            filesProdotti.push(pp);
          }
        }
      }
      // ------------------------------------------------
      await configurazioni.modificaConfigurazione(elenco);
      await configurazioni.invalidaCache("totem", "totem");
      setTimeout(async () => {
        await this.getDataFromApi();
      }, 500);
      this.triggerUpdate++;
    },
    async onChangeFile({ codiceTotem, tipo, payload, codiceItem }) {
      let elenco = await configurazioni.getConfigurazione("totem");
      let totem = elenco.totem.find((x) => x.codice === codiceTotem);
      switch (tipo) {
        case "addFile":
          let item = this.findDirRecurse(totem.alberaturaAssets, codiceItem);
          delete item.trovato;
          for (let al of payload) {
            item.files = item.files || [];
            item.files.push(al);
          }
          break;
        case "updateFile":
          for (let al of payload) {
            let allegato = this.findRecurse(
              totem.alberaturaAssets,
              al.codice,
              al
            );

            if (allegato) {
              allegato.name = al.name;
              allegato.lockedName = al.lockedName || ''
              allegato.pathFile = al.pathFile;
              allegato.type = al.type;
              allegato.size = al.size;
              allegato.descrizione = al.descrizione;
            }
            await this.registraTodo("update", codiceTotem, totem, al);
          }
          break;
        case "deleteFile":
          await this.registraTodo("delete", codiceTotem, totem, payload);
          this.deleteRecurse(totem.alberaturaAssets, payload.codice);
          const info = await configurazioni.getInfoUpload();
          await configurazioni.deleteAttachmentFile(
            info.service,
            info.base,
            null,
            null,
            codiceTotem,
            payload.name,
            payload.codice
          );
          break;
        default:
          break;
      }
      await configurazioni.modificaConfigurazione(elenco);
      await configurazioni.invalidaCache("totem", "totem");
      setTimeout(async () => {
        await this.getDataFromApi();
      }, 500);
      this.triggerUpdate++;
    },
    async registraTodo(operation, codiceTotem, totem, al) {
      this.destinazione = [];
      this.componeDestinazione(totem.alberaturaAssets, al.codice);
      this.destinazione.push(totem.alberaturaAssets.name);
      this.destinazione.push("assets");
      const infoFile = {
        fileCode: al.codice,
        fileName: al.lockedName || al.name,
        filePath: al.pathFile,
        destination: this.destinazione.reverse().join("/"),
      };
      await configurazioni.registraTodo({
        actor: "totem",
        id: codiceTotem,
        type: "image",
        operation: operation,
        payload: infoFile,
      });
    },
    findRecurse(alberatura, codice, payload) {
      var item;
      if (alberatura.cartelle && alberatura.cartelle.length > 0) {
        for (let d of alberatura.cartelle) {
          item = this.findRecurse(d, codice, payload);
        }
      }
      if (alberatura.files && alberatura.files.length > 0) {
        for (let f of alberatura.files) {
          if (f.codice === codice) {
            item = f;
            if (payload) {
              f.pathFile = payload.pathFile;
              f.type = payload.type;
              f.size = payload.size;
              f.name = payload.name;
              f.descrizione = payload.descrizione;
            }
            break;
          }
        }
      }
      return item;
    },
    findDirRecurse(alberatura, codice) {
      var item;
      if (alberatura.trovato) {
        return alberatura;
      }
      if (alberatura.cartelle && alberatura.cartelle.length > 0) {
        for (let d of alberatura.cartelle) {
          if (d.codice === codice) {
            item = d;
            item.trovato = true;
            break;
          } else {
            item = this.findDirRecurse(d, codice);
            if (item && item.trovato) {
              break;
            }
          }
        }
      }
      return item;
    },
    deleteRecurse(alberatura, codice) {
      var item;
      /*         if (alberatura.deletable) {
          return alberatura
        }    */

      if (alberatura.cartelle && alberatura.cartelle.length > 0) {
        for (let d of alberatura.cartelle) {
          item = this.deleteRecurse(d, codice);
        }
      }
      if (alberatura.files && alberatura.files.length > 0) {
        for (let f of alberatura.files) {
          item = f;
          if (f.codice === codice) {
            if (alberatura.aggiuntaLiberaFile) {
              // Se posso aggiungere file --> cancello riferimento e file fisico
              const idx = alberatura.files.findIndex(
                (x) => x.codice === codice
              );
              alberatura.files.splice(idx, 1);
            } else {
              // Se non posso aggiungere file (fissi) --> cancello file fisico e pulisco path su riferimento
              f.pathFile = "";
              f.size = "";
              f.type = "???";
              f.name = "";
            }
            break;
          }
        }
      }
      return item;
    },
    componeDestinazione(alberatura, codice) {
      let item = {};
      if (alberatura.cartelle && alberatura.cartelle.length > 0) {
        for (let d of alberatura.cartelle) {
          item = this.componeDestinazione(d, codice);
          if (item && item.trovato) {
            this.destinazione.push(d.name);
            break;
          }
        }
      }
      if (alberatura.files && alberatura.files.length > 0) {
        for (let f of alberatura.files) {
          if (f.codice === codice) {
            item.trovato = true;
            break;
          }
        }
      }
      return item;
    },
    onItemExpanded(obj) {
      this.trigRefreshProdotti++
      this.mostraAnteprima = obj.value ? obj.item.codice : null
      this.impostaInfoAnteprima()
    },
    async onPrimaInstallazione(codiceTotem) {
      if (window.confirm('Confermi l\'invio di tutte le immagini al totem ? \n\n Viene richiesto il download completo!')) {
        await this.primaInstallazione(codiceTotem)
      }
    },
    async primaInstallazione(codiceTotem) {
      let elenco = await configurazioni.getConfigurazione("totem")
      let totem = elenco.totem.find((x) => x.codice === codiceTotem)
      await this.registraElementi(totem.alberaturaAssets, totem)
    },
    async registraElementi(item, totem) {
      if (item.cartelle && item.cartelle.length > 0) {
        for (let el of item.cartelle) {
          await this.registraElementi(el, totem)
        }
      }
      if (item.files && item.files.length > 0) {
        for (let el of item.files) {
          await this.registraTodo("update", totem.codice, totem, el)
        }
      }
    }
  },
};
</script>

<style lang="scss">
tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
td.articoliSelected {
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #1976d2 !important;
}
</style>
